import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPluginUpdatePatch = {
    path: "/plugin-update/:slug",
    method: RouteHttpVerb.PATCH
};
export { locationRestPluginUpdatePatch };
